//init
import axios from 'axios'

const xrpl = require('xrpl')
const wallet = xrpl.Wallet.fromSeed(process.env.REACT_APP_XRPL_BASE_SCRT)
const client = new xrpl.Client("wss://xls20-sandbox.rippletest.net:51233")



// ------------------------ //
export const XTokenMint = async (item) => {

  const wallet = xrpl.Wallet.fromSeed(item.scrt)
  console.log(wallet.classicAddress)

  const datx = {
		TransactionType: "NFTokenMint",
		Account: wallet.classicAddress,
		URI: xrpl.convertStringToHex(item.link),
		Flags: parseInt(1),
		TokenTaxon: 0 //Required, but if you have no use for it, set to zero.
	}
  
  await client.connect()
  console.log("Connected to Sandbox: Mint")
  const result = await client.submitAndWait(datx,{wallet})
  
  console.log(result)

  // var data = {}
  // if (result) {

  //   const indx = result.result.meta.AffectedNodes.findIndex(item => item.ModifiedNode.LedgerEntryType==='NFTokenPage')
  //   console.log (indx)
    
  //   var tokens =  result.result.meta.AffectedNodes[indx].ModifiedNode.FinalFields.NonFungibleTokens
  //   var count =  result.result.meta.AffectedNodes[indx].ModifiedNode.FinalFields.NonFungibleTokens.length

  //   var tokenx = tokens[count-1]['NonFungibleToken']
  //   // console.log (tokenx)

  //   data = {
  //     trid: result.id,
  //     stat: result.result.meta.TransactionResult,
  //     feex: result.result.Fee,
  //     acnt: result.result.Account,
  //     form: result.result.TransactionType,
  //     hash: result.result.hash,
  //     tkid: tokenx.TokenID,
  //     turi: tokenx.URI
  //   }

  //   console.log(data)
  // }
  client.disconnect()
  if (result.result.meta.TransactionResult === 'tesSUCCESS') return true
  else return false

}

export const XGetUserTokens = async (item) => {
  
	// const wallet = xrpl.Wallet.fromSeed(item.scrt)
	await client.connect()

	console.log("Connected to Sandbox: Get User Tokens")
	const result = await client.request({
		method: "account_nfts",
		// account: wallet.classicAddress
    account: item.acnt
	})
	console.log(result)
	
  client.disconnect()

  var docx = result.result.account_nfts

  for (let x=0; x<docx.length; x++) {

    var urlx = xrpl.convertHexToString(docx[x].URI)
    var urlz = 'https://ipfs.io/ipfs/' + urlx.toString().substring(7)

    var metadata = await axios.get(urlz) 
    // const json = await metadata.json();
    console.log(metadata.data)
    docx[x] = {...docx[x], ...metadata.data}
  }

  return docx
}


export const XTokenTransfer = async (item) => {
  await client.connect()
  console.log("Connected to Sandbox: Transfer")
  
  console.log(wallet.classicAddress)

}

export const XGetClassicAddress = async (item) => {
  const wallet = xrpl.Wallet.fromSeed(item)
  return(wallet.classicAddress)
}